// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.position = 'absolute';
  container.style.inset = '0';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '3';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const eventContainer = event.currentTarget || image;
  const container = eventContainer.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const width = container.width || image.clientWidth || image.width;
  const height = container.height || image.clientHeight || image.height;
  const xPercent = `${(xPosition / width) * 100}%`;
  const yPercent = `${(yPosition / height) * 100}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  return overlay;
}

function removeMagnifyOverlay(image) {
  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (overlay) overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const isDesktopDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!isDesktopDevice) return;

  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    const clickTarget = image.closest('.product__modal-opener--image') || image;
    if (!clickTarget || clickTarget.dataset.magnifyBound === 'true') return;
    clickTarget.dataset.magnifyBound = 'true';

    clickTarget.addEventListener('click', (event) => {
      const existingOverlay = image.parentElement.querySelector('.image-magnify-full-size');
      if (existingOverlay) {
        event.preventDefault();
        event.stopPropagation();
        removeMagnifyOverlay(image);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      const overlay = magnify(image, zoomRatio);
      if (overlay) moveWithHover(image, overlay, event, zoomRatio);

      const moveHandler = (moveEvent) => {
        const activeOverlay = image.parentElement.querySelector('.image-magnify-full-size');
        if (!activeOverlay) {
          clickTarget.removeEventListener('mousemove', moveHandler);
          return;
        }
        moveWithHover(image, activeOverlay, moveEvent, zoomRatio);
      };

      clickTarget.addEventListener('mousemove', moveHandler);
    }, true);
  });
}

enableZoomOnHover(2);
